import React from 'react';
import './Tag.css';
import '../styles/styles.css'
import { Caption1 } from './Text';
import { Icon } from './Icon';

interface TagProps {

  /** . */
  text1?: string;

  /** . */
  status?: 'neutral' | 'positive' | 'negative' | 'notice' | 'informative';

  // icon1Name?: string;
  // svgPath?: string;
}

const Tag: React.FC<TagProps> = ({ text1, status = 'positive' }) => {
  const className = `h-stack width-hug hug-height middle tag-element tag-${status}`;
  return (<>
    <div className={className}>
      {/* {icon1Name && (<Icon size='16px' name={icon1Name} svgPath={svgPath} />)} */}
      <h6 className='Caption1'>{text1}</h6>
    </div>
  </>
  )
};

/**
 * # Divider
 * Divides sections by creating a vertical or horizontal line.
 * 
 * [See Documentation](https://themeable.systems/documentation)
 * 
 * ---
 * 
 * ### Style props:
 * `vertical`: Boolean which makes the divider display vertically, rather than horizontally.
 * 
 * `spacing`: Boolean. Really meant for building components and should be used sparingly. Removes baked-in spacing.
 * 
 * `extendRight`: Boolean. This extends the divider's right edge to take up the space of a container.
 * 
 * `extendLeft`: Boolean. This extends the divider's left edge to take up the space of a container.
 */

export { Tag };
